import { CSS, StyleProps } from "@shared/primitive-components"

export const root = (props: StyleProps) => ({
  marginBottom: props.theme.spacing(4),
})

export const makeLabelStyle =
  (inModal?: boolean) =>
  (props: StyleProps): CSS => ({
    display: `block`,
    flex: inModal ? `0 0 137px` : `0 0 220px`,
    marginRight: props.theme.spacing(4),
  })

export const makeFieldStyle = (inModal?: boolean) => () => ({
  flex: inModal ? `0 0 246px` : `0 0 450px`,
})

export const marker = (props: StyleProps): CSS => ({
  marginLeft: props.theme.spacing(1),
  display: `inline`,
})
